import React from 'react';
import { Box, Button, Icon, Paper, SxProps } from '@mui/material';
import { buttons, Colors } from '../../../utils/theme';
import { fonts } from '../../../utils/fontStyles';
import { CreateButtonProps } from '../Tables/OverviewTable';

export interface NavigationButtonProps {
  id: string;
  text: string;
  onClick: () => void;
}

interface IProps {
  width: string;
  children: React.ReactNode;
  additionalStyle?: SxProps;
  headerText?: string;
  createButtonProps?: CreateButtonProps;
  navigationButton?: NavigationButtonProps;
}

const PaperCard: React.FunctionComponent<IProps> = ({
  width,
  children,
  additionalStyle,
  headerText,
  createButtonProps,
  navigationButton
}) => {
  return (
    <Paper
      square
      sx={{
        width: width,
        boxShadow: '0px 10px 20px ' + Colors.third + '66',
        ...additionalStyle
      }}
    >
      {(headerText || createButtonProps) && (
        <Box
          className="centralize"
          sx={{
            ...fonts.Predefined.Bold['22px33px'],
            borderBottom: `2px solid ${Colors.skyBlue}`,
            color: Colors.skyBlue,
            paddingY: '7px',
            position: 'relative'
          }}
        >
          {navigationButton && (
            <Button
              id={navigationButton.id}
              data-testid={navigationButton.id}
              onClick={navigationButton.onClick}
              sx={{
                position: 'absolute',
                left: '20px',
                top: '7px'
              }}
            >
              <Icon sx={{ color: (t) => t.palette.primary.main, marginRight: '4px' }}>
                {'chevron_left'}
              </Icon>
              {navigationButton.text}
            </Button>
          )}
          {createButtonProps && (
            <Button
              id={createButtonProps.id}
              data-testid={createButtonProps.id}
              sx={{
                ...buttons.createSecondary,
                position: 'absolute',
                left: navigationButton ? '150px' : '20px',
                top: '7px'
              }}
              onClick={() => createButtonProps.onClick()}
              disabled={createButtonProps.disabled ?? false}
            >
              {createButtonProps.text}
            </Button>
          )}
          {headerText}
        </Box>
      )}
      <Box sx={{ height: '100%' }}>{children}</Box>
    </Paper>
  );
};

export default PaperCard;
